const API_BASE = process.env.REACT_APP_API_BASE_URL || '';
const JSON_HEADERS = { 'Content-Type': 'application/json' };

const handleResponse = async (response) => {
  let data = null;
  try {
    data = await response.json();
  } catch (_) {
    data = null;
  }

  if (!response.ok) {
    const message = data?.detail || data?.message || 'Unable to complete request';
    throw new Error(message);
  }
  return data;
};

export const saveKey = async (accessToken, { provider, key }) => {
  const response = await fetch(`${API_BASE}/keys/llm`, {
    method: 'POST',
    headers: {
      ...JSON_HEADERS,
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ provider, api_key: key }),
  });
  return handleResponse(response);
};

export const getKeyStatus = async (accessToken, provider) => {
  const response = await fetch(`${API_BASE}/keys/llm?provider=${encodeURIComponent(provider)}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return handleResponse(response);
};
